/**
 * Partitions a flat set of item IDs into a per-stage record, so each column
 * can be handed only the subset of IDs that belong to it. Every stage key
 * present in `itemsByStage` always gets an entry (possibly an empty Set) —
 * callers can index by `stage.id` without an `?? new Set()` fallback.
 */
export function groupIdsByStage<Item, ItemId, StageId extends string>(
  itemsByStage: Record<StageId, readonly Item[]>,
  getItemId: (item: Item) => ItemId,
  ids: ReadonlySet<ItemId>
): Record<StageId, ReadonlySet<ItemId>> {
  const result: Partial<Record<StageId, ReadonlySet<ItemId>>> = {};

  for (const stageId of Object.keys(itemsByStage) as StageId[]) {
    const stageSet = new Set<ItemId>();
    if (ids.size > 0) {
      for (const item of itemsByStage[stageId]) {
        const itemId = getItemId(item);
        if (ids.has(itemId)) {
          stageSet.add(itemId);
        }
      }
    }
    result[stageId] = stageSet;
  }

  return result as Record<StageId, ReadonlySet<ItemId>>;
}
